import { Button, FieldContainer, TextArea } from '@pata-app/core';

import React from 'react';
import Select from 'react-select';
import { useTheme } from 'styled-components';
import { BaseOptions } from 'vm';

import Icon from '../../../../../components/icon/icon';
import useForm from '../../../../../hooks/useForm/useForm';
import { usePostBusinessReview } from '../businessReviews.queries';
import { REVIEW_RATINGS } from './addReview.config';
import { FormContainer, RatingButton, RatingContainer } from './addReview.styled';

interface IWriteReview {
  businessName: string;
  setReviewStage: (stage: number) => void;
  form: ReturnType<typeof useForm>;
  setShowAddReview: (show: boolean) => void;
}

export const AddReviewForm = ({ businessName, form }: IWriteReview) => {
  const theme = useTheme();

  const { formState, formErrors, handleFieldChange } = form;

  const handleTextInputChange = (name: string, value: string) => {
    handleFieldChange(name, value);
  };

  const handleRatingSelection = (event, value: number) => {
    event.preventDefault();
    handleFieldChange('rating', value);
  };


  return (
    <FormContainer>
      <h2>How was your experience at {businessName}?</h2>

      <RatingContainer>
        {REVIEW_RATINGS.map((rating) => (
          <RatingButton key={rating} onClick={(event) => handleRatingSelection(event, rating)}>
            <Icon
              type="Star"
              size="40px"
              fill={
                formState.rating && formState.rating >= rating
                  ? theme.core.colors.secondary.yellow.medium
                  : theme.core.colors.greyscale.medium
              }
            />
          </RatingButton>
        ))}
      </RatingContainer>

      <FieldContainer label="What did you like? What could we have done better?" error={formErrors.text[0]}>
        <TextArea
          value={formState.text}
          onChange={(event) => handleTextInputChange('text', event.target.value)}
          rows={10}
          maxCharacterLength={500}
        />
      </FieldContainer>
    </FormContainer>
  );
};
